import '@/sui/less/all.less'
import '@babel/polyfill'

import 'chartjs-plugin-datalabels'

import Vue from 'vue'

import check from '@/check'

import initComponents from '@/sui/components/init'
import init from '@/sui/api/init'
import app from '@/app'
import router from '@/router'
import store from '@/store'

import * as uiv from 'uiv'
import moment from 'moment'
import locale from 'uiv/src/locale/lang/fr-FR'
import vueAsyncComputed from 'vue-async-computed'
import vueSticky from 'vue-sticky-directive'
import vueShortKey from 'vue-shortkey'

Vue.config.productionTip = false
Vue.use(uiv, { locale })
Vue.use(vueAsyncComputed)
Vue.use(vueSticky)
Vue.use(vueShortKey)

moment.locale('fr')

window.isSpiadiBackOffice = true

store.dispatch('cloud/getConfig')

initComponents()
check()

new Vue({
  created: function () {
    init(store, 'login', router)
  },
  router,
  store,
  render: h => h(app)
}).$mount('#app')
